<mat-expansion-panel hideToggle class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ props.label }}</mat-panel-title>
    <mat-panel-description>{{ props.description }}</mat-panel-description>
  </mat-expansion-panel-header>
  <p>
    <ng-container #fieldComponent></ng-container>
  </p>
</mat-expansion-panel>
